import { createSlice } from "@reduxjs/toolkit";
import { pending_programmes } from "../../../types/core_ibass";

export const allProgrammes = createSlice({
  name: "all_programmes",
  initialState: {
    value: {
      status: false,
      data: [] as pending_programmes,
    },
  },
  reducers: {
    update_programmes: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload?.data;
    },
    add_programme: (state, action) => {
      state.value.data = [...state.value.data, action?.payload];
    },
    remove_programme: (state, action) => {
      const { id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => Number(v.id) === id
      );
      currentArray.splice(currentIndex, 1);
      state.value.data = currentArray;
    },
    replace_programme: (state, action) => {
      const { id } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => v.id === id
      );
      currentArray.splice(currentIndex, 1, action?.payload);
      state.value.data = currentArray;
    },
    clear_programmes: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  update_programmes,
  add_programme,
  remove_programme,
  replace_programme,
  clear_programmes,
} = allProgrammes.actions;

export default allProgrammes.reducer;
